(() => {
  if (customElements.get('somdul-source-products')) return;
  const requests = new Map();
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const normalise = value => String(value || '').normalize('NFKC').toLocaleLowerCase().trim();
  const brandKey = value => normalise(value).replace(/[.\s]/g,'');
  customElements.define('somdul-source-products', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.defer === 'true') return;
      if (this.started) {
        window.addEventListener('popstate', this.onPopState);
        this.connectFilters();
        return;
      }
      this.started = true;
      this.labels = JSON.parse(this.querySelector('[data-source-labels]').textContent);
      this.categories = JSON.parse(this.querySelector('[data-source-categories]').textContent);
      this.locale = this.dataset.locale || 'en';
      this.catalogBase = new URL(window.location.href).searchParams.get('view') === 'product-catalog' ? this.dataset.productBase : this.dataset.catalogUrl;
      this.products = [];
      this.byId = new Map();
      this.state = { q: '', brand: '', department:'', subcategory:'', page: 1, sku: '' };
      this.search = this.querySelector('[data-ssp-search]');
      this.brand = this.querySelector('[data-ssp-brand]');
      this.department = this.querySelector('[data-ssp-department]');
      this.subcategory = this.querySelector('[data-ssp-subcategory]');
      this.filterToggle = this.querySelector('[data-ssp-filter-toggle]');
      this.filterPanel = this.querySelector('[data-ssp-filter-panel]');
      this.filtersExpanded = false;
      this.filtersMedia = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 749px)') : null;
      this.onFiltersMediaChange = () => this.updateFilters();
      this.connectFilters();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-ssp-id], [data-ssp-back]');
        if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          event.preventDefault();
          this.setState({sku: link.dataset.sspId || ''}, true);
        }
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        if (button.hasAttribute('data-ssp-filter-toggle')) {
          this.filtersExpanded = !this.filtersExpanded;
          this.updateFilters();
        }
        if (button.hasAttribute('data-ssp-clear')) this.setState({q:'',brand:'',department:'',subcategory:'',page:1,sku:''});
        if (button.hasAttribute('data-ssp-prev')) this.setState({page:this.state.page-1}, true);
        if (button.hasAttribute('data-ssp-next')) this.setState({page:this.state.page+1}, true);
        if (button.hasAttribute('data-ssp-page')) this.setState({page:Number(button.dataset.sspPage)}, true);
        if (button.hasAttribute('data-ssp-retry')) this.load(true);
      });
      this.querySelector('[data-ssp-search-form]').addEventListener('submit', event => {event.preventDefault();this.setState({q:this.search.value,page:1});});
      this.search.addEventListener('input', () => this.setState({q:this.search.value,page:1}, false, 'replaceState'));
      this.brand.addEventListener('change', () => this.setState({brand:this.brand.value,page:1}));
      this.department.addEventListener('change', () => this.setState({department:this.department.value,subcategory:'',page:1}));
      this.subcategory.addEventListener('change', () => this.setState({subcategory:this.subcategory.value,page:1}));
      this.onPopState = () => {if(this.loaded)this.setState(this.readLocation(), false, false);};
      window.addEventListener('popstate', this.onPopState);
      this.load();
    }
    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
      if (this.filtersMedia?.removeEventListener) this.filtersMedia.removeEventListener('change', this.onFiltersMediaChange);
      else this.filtersMedia?.removeListener?.(this.onFiltersMediaChange);
    }
    connectFilters() {
      if (this.filtersMedia?.addEventListener) this.filtersMedia.addEventListener('change', this.onFiltersMediaChange);
      else this.filtersMedia?.addListener?.(this.onFiltersMediaChange);
      this.updateFilters();
    }
    updateFilters() {
      if (!this.filterToggle || !this.filterPanel) return;
      const mobile = Boolean(this.filtersMedia?.matches);
      const expanded = !mobile || this.filtersExpanded;
      const focusInPanel = this.filterPanel.contains(document.activeElement);
      const focusOnToggle = document.activeElement === this.filterToggle;
      this.filterToggle.hidden = !mobile;
      if (!expanded && focusInPanel) this.filterToggle.focus({preventScroll:true});
      if (!mobile && focusOnToggle) this.search.focus({preventScroll:true});
      this.filterToggle.setAttribute('aria-expanded', String(expanded));
      this.filterPanel.hidden = !expanded;
      const count = ['department','subcategory','brand'].filter(key => this.state[key]).length;
      const badge = this.querySelector('[data-ssp-filter-count]');
      if (badge) { badge.textContent = '(' + count + ')'; badge.hidden = count === 0; }
    }
    text(key, replacements = {}) {
      return Object.entries(replacements).reduce((text,[key,value])=>text.replaceAll('['+key+']',String(value)),this.labels[key] || key);
    }
    async load(retry = false) {
      this.querySelector('[data-ssp-error]').hidden = true;
      this.querySelector('[data-ssp-count]').textContent = this.text('loading');
      try {
        const embedded = document.getElementById('somdul-source-products-data');
        let manifest;
        if (embedded) manifest = JSON.parse(embedded.textContent);
        else {
          const url = new URL(this.dataset.sourceUrl, window.location.href);
          if (!['https:','http:'].includes(url.protocol)) throw new Error('Invalid product source');
          if(retry)requests.delete(url.href);
          if(!requests.has(url.href))requests.set(url.href,fetch(url.href,{credentials:'omit'}).then(response=>{if(!response.ok)throw new Error('Product source unavailable');return response.json();}));
          manifest = await requests.get(url.href);
        }
        if(!manifest || !Array.isArray(manifest.products))throw new Error('Invalid products');
        const seen = new Set();
        this.products = manifest.products.filter(product => {
          if(!product || typeof product.id !== 'string' || !/^[a-z0-9][a-z0-9_-]{0,79}$/.test(product.id) || seen.has(product.id))return false;
          seen.add(product.id);return true;
        });
        this.currency = /^[A-Z]{3}$/.test(manifest.currency || '') ? manifest.currency : 'USD';
        this.byId = new Map(this.products.map(product=>[product.id,product]));
        this.brandLabels = new Map();
        this.products.forEach(product=>{const label=String(product.brand || '').trim(),key=brandKey(label);if(key&&!this.brandLabels.has(key))this.brandLabels.set(key,label);});
        this.brands = [...this.brandLabels.keys()].sort((a,b)=>this.brandLabels.get(a).localeCompare(this.brandLabels.get(b)));
        this.brand.replaceChildren(node('option','',this.text('all_brands')));
        this.brand.firstChild.value = '';
        this.brands.forEach(brand=>{const option=node('option','',this.brandLabels.get(brand));option.value=brand;this.brand.append(option);});
        this.departments=Object.keys(this.categories.departments);
        this.fillSelect(this.department,this.departments,this.categories.departments,'all_departments');
        this.querySelectorAll('[disabled]').forEach(control=>{control.disabled=false;});
        this.loaded = true;
        const requested = this.readLocation();
        const invalid = requested.sku && !this.byId.has(requested.sku);
        this.setState(requested,false,false);
        if(invalid)this.querySelector('[data-ssp-status]').textContent=this.text('unknown_product');
      } catch(error) {
        this.querySelector('[data-ssp-count]').textContent='';
        this.querySelector('[data-ssp-error]').hidden=false;
      }
    }
    readLocation() {
      const params = new URL(window.location.href).searchParams;
      return {q:params.get('source_q')||'',brand:params.get('source_brand')||'',department:params.has('source_department')?params.get('source_department'):(this.departments.includes(this.dataset.initialDepartment)?this.dataset.initialDepartment:''),subcategory:params.get('source_subcategory')||'',page:Number(params.get('source_page'))||1,sku:params.get('sku')||''};
    }
    setState(next = {}, focus = false, history = 'pushState') {
      const merged={...this.state,...next};
      const department=this.departments.includes(merged.department)?merged.department:'';
      this.subcategories=Object.keys(this.categories.subcategories).filter(id=>this.products.some(product=>product.subcategory===id&&(!department||product.department===department)));
      const brand=brandKey(merged.brand);
      this.state={q:String(merged.q || '').slice(0,120),brand:this.brands.includes(brand)?brand:'',department,subcategory:this.subcategories.includes(merged.subcategory)?merged.subcategory:'',page:Number.isSafeInteger(Number(merged.page))&&Number(merged.page)>0?Number(merged.page):1,sku:this.byId.has(merged.sku)?merged.sku:''};
      const q=normalise(this.state.q);
      this.matches=this.products.filter(product=>(!this.state.brand||brandKey(product.brand)===this.state.brand)&&(!this.state.department||product.department===this.state.department)&&(!this.state.subcategory||product.subcategory===this.state.subcategory)&&(!q||normalise([product.title,product.brand,product.sku,product.pack].join(' ')).includes(q)));
      this.totalPages=Math.max(1,Math.ceil(this.matches.length/24));
      this.state.page=Math.min(this.state.page,this.totalPages);
      this.render();
      if(history)this.syncLocation(history);
      this.syncLanguageReturn();
      if(focus){const heading=this.querySelector(this.state.sku?'[data-ssp-product] h1':'[data-ssp-heading]');heading?.focus({preventScroll:true});this.scrollIntoView({block:'start',behavior:'instant'});}
    }
    url(sku='') {
      const base=sku?this.dataset.productBase:this.catalogBase;
      const url=new URL(base,window.location.href);
      if(url.origin!==window.location.origin && window.location.protocol!=='file:')return '#';
      if(this.state.q)url.searchParams.set('source_q',this.state.q);
      if(this.state.brand)url.searchParams.set('source_brand',this.state.brand);
      if(this.state.department)url.searchParams.set('source_department',this.state.department);
      if(this.state.subcategory)url.searchParams.set('source_subcategory',this.state.subcategory);
      if(this.state.page>1)url.searchParams.set('source_page',String(this.state.page));
      if(sku)url.searchParams.set('sku',sku);
      const preview=new URL(window.location.href).searchParams.get('preview_theme_id');
      if(/^\d+$/.test(preview||''))url.searchParams.set('preview_theme_id',preview);
      return url.pathname+url.search;
    }
    syncLocation(method) {
      try {
        const current=new URL(window.location.href);
        if(this.dataset.standalone==='true') {
          for(const key of ['source_q','source_brand','source_department','source_subcategory','source_page','sku'])current.searchParams.delete(key);
          const target=new URL(this.url(this.state.sku),'https://somdul.invalid');
          for(const [key,value]of target.searchParams)if(key!=='view')current.searchParams.set(key,value);
          window.history[method](null,'',current.pathname+current.search);
        } else {
          const target=this.url(this.state.sku);
          if(current.pathname+current.search!==target)window.history[method](null,'',target);
        }
      } catch(error) {}
    }
    syncLanguageReturn() {
      const target=this.url(this.state.sku);
      document.querySelectorAll('form[action$="/localization"]').forEach(form=>{
        const action=new URL(form.action,window.location.href);
        if(action.origin!==window.location.origin)return;
        let input=form.querySelector('input[name="return_to"]');
        if(!input){input=node('input');input.type='hidden';input.name='return_to';form.append(input);}
        input.value=target;
      });
    }
    price(product) {
      const value=String(product.retailPrice ?? '');
      if(!/^\d+(?:\.\d{1,2})?$/.test(value))return this.text('price_pending');
      return new Intl.NumberFormat(this.locale,{style:'currency',currency:this.currency,currencyDisplay:'code',minimumFractionDigits:2}).format(Number(value));
    }
    placeholder() {
      const placeholder=node('span','ssp__brand-placeholder');
      placeholder.setAttribute('role','img');
      placeholder.setAttribute('aria-label','SOMDUL · '+this.text('image_pending'));
      const wordmark=()=>placeholder.replaceChildren(node('span','ssp__placeholder-wordmark','SOMDUL'));
      if(this.dataset.placeholderLogo){
        const logo=node('img','ssp__placeholder-logo');
        logo.alt='';logo.decoding='async';
        logo.addEventListener('error',wordmark,{once:true});
        logo.src=this.dataset.placeholderLogo;
        placeholder.append(logo);
      }else wordmark();
      return placeholder;
    }
    media(product,large=false) {
      const box=node(large?'div':'a',large?'ssp__photo':'ssp-card__media');
      if(!large){box.href=this.url(product.id);box.dataset.sspId=product.id;box.setAttribute('aria-label',product.title||product.sku);}
      let src='';
      try{
        const value=new URL(product.image||'',window.location.href);
        if(product.image&&(['https:','http:'].includes(value.protocol)||(/^data:image\/(png|jpeg|webp);base64,/.test(product.image)&&this.dataset.standalone==='true'))){
          if(value.protocol==='https:'&&value.hostname==='cdn.shopify.com'){
            const limit=large?1200:600,originalWidth=Number(product.imageWidth);
            value.searchParams.set('width',String(Number.isFinite(originalWidth)&&originalWidth>=1?Math.min(Math.floor(originalWidth),limit):limit));
          }
          src=value.href;
        }
      }catch(error){}
      const showPlaceholder=()=>{box.replaceChildren(this.placeholder());if(!large)box.setAttribute('aria-label',(product.title||product.sku)+' · '+this.text('image_pending'));};
      if(product.imageStatus!=='ready'||!src){showPlaceholder();return box;}
      const bounds=product.imageBounds,width=Number(product.imageWidth),height=Number(product.imageHeight);
      if(bounds&&width>0&&height>0&&['x','y','width','height'].every(key=>Number.isFinite(Number(bounds[key])))&&bounds.x>=0&&bounds.y>=0&&bounds.width>0&&bounds.height>0&&bounds.x+bounds.width<=width&&bounds.y+bounds.height<=height) {
        const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.classList.add('ssp__source-image');svg.setAttribute('viewBox',[bounds.x,bounds.y,bounds.width,bounds.height].join(' '));svg.setAttribute('role','img');svg.setAttribute('aria-label',product.title||product.sku);svg.setAttribute('preserveAspectRatio','xMidYMid meet');
        const image=document.createElementNS(svg.namespaceURI,'image');image.setAttribute('width',String(width));image.setAttribute('height',String(height));image.setAttribute('href',src);image.addEventListener('error',showPlaceholder,{once:true});svg.append(image);box.append(svg);
      } else {
        const image=node('img');image.src=src;image.alt=product.title||product.sku;image.loading=large?'eager':'lazy';image.decoding='async';image.addEventListener('error',showPlaceholder,{once:true});box.append(image);
      }
      return box;
    }
    card(product) {
      const card=node('li','ssp-card');card.dataset.productId=product.id;card.append(this.media(product));
      const body=node('div','ssp-card__body');
      if(product.brand)body.append(node('p','ssp-card__brand',product.brand));
      const heading=node('h2'),link=node('a','',product.title||product.sku);link.href=this.url(product.id);link.dataset.sspId=product.id;heading.append(link);body.append(heading);
      if(product.pack)body.append(node('p','ssp-card__pack',product.pack));
      body.append(node('p','ssp-card__price'+(product.retailPrice==null?' ssp-card__price--pending':''),this.price(product)));
      const details=node('a','ssp-card__details');details.href=link.href;details.dataset.sspId=product.id;details.append(node('span','',this.text('details')),node('span','','→'));details.lastChild.setAttribute('aria-hidden','true');body.append(details);card.append(body);return card;
    }
    render() {
      this.search.value=this.state.q;this.brand.value=this.state.brand;
      this.department.value=this.state.department;
      this.fillSelect(this.subcategory,this.subcategories,this.categories.subcategories,'all_subcategories');
      this.subcategory.value=this.state.subcategory;
      this.updateFilters();
      this.querySelector('[data-ssp-status]').textContent='';
      this.querySelector('[data-ssp-catalog]').hidden=Boolean(this.state.sku);
      const productView=this.querySelector('[data-ssp-product]');productView.hidden=!this.state.sku;
      if(this.state.sku){this.renderProduct(this.byId.get(this.state.sku));return;}
      const start=(this.state.page-1)*24;
      this.querySelector('[data-ssp-grid]').replaceChildren(...this.matches.slice(start,start+24).map(product=>this.card(product)));
      this.querySelector('[data-ssp-count]').textContent=this.text('results',{from:this.matches.length?start+1:0,to:Math.min(start+24,this.matches.length),count:this.matches.length});
      this.querySelector('[data-ssp-empty]').hidden=this.matches.length>0;
      this.querySelector('[data-ssp-pagination]').hidden=this.totalPages<=1;
      this.querySelector('[data-ssp-prev]').disabled=this.state.page<=1;
      this.querySelector('[data-ssp-next]').disabled=this.state.page>=this.totalPages;
      const pages=this.querySelector('[data-ssp-pages]');pages.replaceChildren();
      const first=Math.max(1,Math.min(this.state.page-2,this.totalPages-4)),last=Math.min(this.totalPages,first+4);
      for(let page=first;page<=last;page++){const button=node('button','',String(page));button.type='button';button.dataset.sspPage=String(page);button.setAttribute('aria-label',this.text('page')+' '+page);if(page===this.state.page)button.setAttribute('aria-current','page');pages.append(button);}
    }
    renderProduct(product) {
      const view=this.querySelector('[data-ssp-product]');view.replaceChildren();
      const back=node('a','ssp__back','← '+this.text('back'));back.href=this.url();back.dataset.sspBack='';view.append(back);
      const grid=node('div','ssp__product-grid'),info=node('div','ssp__product-info');grid.append(this.media(product,true),info);
      if(product.brand)info.append(node('p','ssp__product-brand',product.brand));
      const heading=node('h1','',product.title||product.sku);heading.tabIndex=-1;info.append(heading);
      if(product.pack)info.append(node('p','ssp__product-pack',product.pack));
      const price=node('div','ssp__price-block');price.append(node('p','ssp__price-label',this.text('retail')),node('p','ssp__product-price',this.price(product)));info.append(price);
      // Source-catalog rows are preliminary data, not purchasable Shopify variants.
      // Keep availability explicit until real products and stock are connected.
      const purchase=node('div','ssp__purchase');
      const add=node('button','ssp__add-to-cart',this.text('add_to_cart'));
      const availability=node('p','ssp__availability',this.text('ordering_pending'));
      availability.id='SourceAvailability-'+this.locale+'-'+product.id;
      add.type='button';add.disabled=true;add.setAttribute('aria-describedby',availability.id);
      purchase.append(add,availability);info.append(purchase);
      if(product.description){const description=node('div','ssp__description');description.append(node('h2','',this.text('description')),node('p','',product.description));info.append(description);}
      if(product.sku)info.append(node('p','ssp__sku',this.text('sku')+' '+product.sku));
      view.append(grid);
    }
    fillSelect(select,ids,labels,allLabel) {
      const all=node('option','',this.text(allLabel));all.value='';select.replaceChildren(all);
      ids.forEach(id=>{const option=node('option','',labels[id]);option.value=id;select.append(option);});
    }
  });
})();
